import React, { memo } from 'react'
import { MapMarker, MapMarkerProps } from './MapMarker'

interface IMapMarkers {
  markers?: MapMarkerProps[]
}

const MapMarkers = ({ markers }: IMapMarkers) => {
  return (
  <>
    {markers?.map((marker) => (
      <MapMarker key={marker.id} {...marker} />
    ))}
  </>
  )
}

export default memo(MapMarkers)
